/* istanbul ignore file */
/* tslint:disable */
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { CreateSSOProviderData, Saml2ProviderJSON } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
import { makeResponses } from '../response_factory';
const makeResult = coreUtils.makeResult;
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function ssoProvider(config) {
    const createResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(Saml2ProviderJSON)),
    });
    return Object.freeze({
        /**
         * Register a new SSO Provider in this instance.
         *
         * Users will be able to login using the registered provider.
         *
         * The request should contain two files. One named `json` containing the json data explained below and one named `logo` containing the backup logo.
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @returns The just created provider.
         */
        create: async ({ requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/sso_providers/`, createResponse.v, JSON.stringify(CreateSSOProviderData.encode(requestBody)));
            return result;
        },
    });
}
